// extracted by mini-css-extract-plugin
export default {"root":"DashboardTermsOfUse_root__xjqj+","container":"DashboardTermsOfUse_container__oPp9P","padding":"DashboardTermsOfUse_padding__oz8le"};